import React, {useState, createContext, useEffect, useCallback} from "react";
import axios from "../axios/axios";

const TasksContext = createContext({
    inProgressTasks: [],
    completedTasks: [],
    fetchTasks: () => {
    },
    isLoading: false,
    error: null,
});

const TasksProvider = ({children, user}) => {
    const [inProgressTasks, setInProgressTasks] = useState([]);
    const [completedTasks, setCompletedTasks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchTasks = useCallback(async () => {
        if (!user?.id) return;

        setIsLoading(true);
        setError(null);

        try {
            const response = await axios.get(`/get/user_task?user_id=${user.id}&completed=all`);

            const allTasks = response.data;
            setInProgressTasks(allTasks.filter(task => task.completed === 0));
            setCompletedTasks(allTasks.filter(task => task.completed === 1));
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    }, [user?.id]);

    useEffect(() => {
        fetchTasks();
    }, [fetchTasks]);

    const value = {
        inProgressTasks,
        completedTasks,
        fetchTasks,
        isLoading,
        error,
    };

    return <TasksContext.Provider value={value}>{children}</TasksContext.Provider>;
};

const useTasks = () => {
    const context = React.useContext(TasksContext);
    if (context === undefined) {
        throw new Error("useTasks must be used within a TasksProvider");
    }
    return context;
};

export {TasksProvider, useTasks};
